import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

import InvestorAccountTable from './InvestorAccountTable';
import InvestorAccountDetails from './InvestorAccountDetails';
import { ListContainer } from 'components';

const InvestorsAccounts = () => {
    const { path } = useRouteMatch();

    return (
        <ListContainer>
            <Switch>
                <Route path={`${path}/details/:userId`} component={InvestorAccountDetails} />
                <Route path={path} render={() => <InvestorAccountTable />} />
            </Switch>
        </ListContainer>
    );
};

export default InvestorsAccounts;
